import * as React from 'react';
import { FC, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import { Box, Grid, IconButton, Typography, useTheme } from '@mui/material';
import { contacts, instagram_qr } from '../../assets/backgrounds';
import LinkRouter from '../LinkRouter';
import { facebook, instagram, mail, telegram, tiktok } from '../../assets/icons';
import { Close } from '@mui/icons-material';
import { fb, inst, tg, tt } from '../../assets/links';

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

interface IProps {
    open: boolean;
    handleClose: () => void;
}

const ContactsDialog: FC<IProps> = ({ open, handleClose }) => {
    const { palette } = useTheme();

    return (
        <Dialog
            open={open}
            TransitionComponent={Transition}
            keepMounted
            onClose={handleClose}
            PaperProps={{
                sx: {
                    minWidth: { xs: "362px", md: "788px", lg: "950px" },
                    maxWidth: { xs: "362px", md: "788px", lg: "950px" },
                    height: { xs: "870px", md: "470px", lg: "550px" },
                    borderRadius: "10px",
                }
            }}
        >
            <DialogContent
                sx={{
                    background: `${palette.primary.dark}`,
                    p: "10px",
                    pt: { xs: "49px", md: "10px" },
                    display: { xs: "block", md: "flex" },
                    alignItems: "center",
                    flexWrap: "wrap",
                    position: "relative"
                }}
            >
                <Box sx={{ width: { xs: "329px", md: "390px", lg: "460px" }, height: { xs: "379px", md: "450px", lg: "530px" } }}>
                    <img
                        loading="lazy" src={contacts} alt="contacts" style={{ width: "inherit", height: "inherit" }} />
                </Box>
                <Box sx={{ width: { xs: "303px", md: "300px", lg: "330px" }, height: { xs: "184px", md: "436px", lg: "492px" }, mx: { xs: "auto", md: "0px" }, pl: { xs: "0px", md: "18px", lg: "40px" } }}>
                    <Typography variant="h2" fontFamily="Druk Wide, sans-serif" textAlign={{ xs: "center", md: "start" }} sx={{ fontSize: { xs: "26px", lg: "h2.fontSize" }, mt: { xs: "18px", md: "0px" } }}>
                        Ми тут. А ти?
                    </Typography>
                    <Box sx={{ width: { xs: "271px", md: "284px", lg: "260px" } }}>
                        <Grid container sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: { xs: "16px", md: "24px" } }}>
                            <Grid item xs={6} sx={{ display: "flex", alignItems: "center" }}>
                                <Box sx={{ width: "32px", height: "32px" }}>
                                    <img
                                        loading="lazy" src={mail} alt="mail" style={{ width: "inherit", height: "inherit" }} />
                                </Box>
                                <Typography variant="h5" fontWeight="600" fontFamily="Fixel Display, sans-serif" sx={{ fontSize: { xs: "18px", md: "h4.fontSize", lg: "h5.fontSize" }, ml: "6px", mr: "16px" }}>
                                    Gmail
                                </Typography>
                            </Grid>
                            <Grid item xs={6} sx={{ display: "flex", alignItems: "center" }}>
                                <Typography
                                    variant="h5"
                                    fontFamily="Fixel Display, sans-serif"
                                    lineHeight={{ xs: "20px", md: "24px" }}
                                    sx={{ wordBreak: { xs: "break-word", md: "unset" }, overflowWrap: { xs: "break-word", md: "unset" } }}
                                >
                                    about.u.kraine25@gmail.com
                                </Typography>
                            </Grid>
                        </Grid>
                        <Grid container sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", my: "16px" }}>
                            <Grid item xs={6} sx={{ display: "flex", alignItems: "center" }}>
                                <Box sx={{ width: "32px", height: "32px" }}>
                                    <img
                                        loading="lazy" src={facebook} alt="facebook" style={{ width: "inherit", height: "inherit" }} />
                                </Box>
                                <Typography variant="h5" fontWeight="600" fontFamily="Fixel Display, sans-serif" sx={{ fontSize: { xs: "18px", md: "h4.fontSize", lg: "h5.fontSize" }, ml: "6px", mr: "16px" }}>
                                    Facebook
                                </Typography>
                            </Grid>
                            <Grid item xs={6} sx={{ display: "flex", alignItems: "center" }}>
                                <Typography
                                    variant="h5"
                                    fontFamily="Fixel Display, sans-serif"
                                    sx={{
                                        textDecoration: 'underline',
                                        cursor: "pointer"
                                    }} onClick={() => { window.open(fb) }}>
                                    @about.u.kraine
                                </Typography>
                            </Grid>
                        </Grid>
                        <Grid container sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <Grid item xs={6} sx={{ display: "flex", alignItems: "center" }}>
                                <Box sx={{ width: "32px", height: "32px" }}>
                                    <img
                                        loading="lazy" src={tiktok} alt="tiktok" style={{ width: "inherit", height: "inherit" }} />
                                </Box>
                                <Typography variant="h5" fontWeight="600" fontFamily="Fixel Display, sans-serif" sx={{ fontSize: { xs: "18px", md: "h4.fontSize", lg: "h5.fontSize" }, ml: "6px", mr: "16px" }}>
                                    TikTok
                                </Typography>
                            </Grid>
                            <Grid item xs={6} sx={{ display: "flex", alignItems: "center" }}>
                                <Typography
                                    variant="h5"
                                    fontFamily="Fixel Display, sans-serif"
                                    sx={{
                                        textDecoration: 'underline',
                                        cursor: "pointer"
                                    }}
                                    onClick={() => { window.open(tt) }}
                                >
                                    @about.u.kraine
                                </Typography>
                            </Grid>
                        </Grid>
                    </Box>
                    <Typography variant="h4" fontSize="20px" lineHeight="28px" fontWeight="700" fontFamily="Fixel Display, sans-serif" sx={{ mt: { xs: "43px", md: "34px", lg: "54px" }, mb: { xs: "12px", md: "16px" } }}>
                        Долучайтесь!
                    </Typography>
                    <Box sx={{ width: { xs: "120px", lg: "150px" }, height: { xs: "138px", lg: "172px", cursor: "pointer" }, mx: { xs: "auto", md: "0px" } }} onClick={() => { window.open(inst) }}>
                        <img
                            loading="lazy" src={instagram_qr} alt="instagram_qr" style={{ width: "inherit", height: "inherit" }} />
                    </Box>
                    <Typography variant="h5" fontFamily="Fixel Display, sans-serif" textAlign={{ xs: "center", md: "start" }} sx={{ mt: "8px" }}>
                        На зв’язку в Direct!
                    </Typography>
                </Box>
                <IconButton disableRipple size="large" sx={{ position: "absolute", right: { xs: "10px", md: "15px" }, top: "10px", p: "0px" }} onClick={handleClose}>
                    <Close fontSize="inherit" />
                </IconButton>
            </DialogContent>
        </Dialog >
    );
}


export default ContactsDialog;
